module.exports = __webpack_public_path__ + "img/256x256_circle_warp_gate.b04625e9.svg";